import React, {Component, PropTypes} from 'react';
import {Map, Record} from 'immutable';
import IconSVG from 'svg-inline-react';
import ClassNames from 'classnames'
import ActionCreators from 'actions/ActionCreators';
import Tip from 'components/TipControl'

import './InfoBlockParametersIcons.scss';

class InfoBlockParametersIcons extends Component {
    static propTypes = {
        parameters: PropTypes.objectOf(Record),
        partDay: PropTypes.instanceOf(Map),
        onChangeService: PropTypes.func,
        services: PropTypes.instanceOf(Map),
    };

    static defaultProps = {
        parameters: {},
    };

    state = {
        loadersChecked: (this.props.parameters.load_loaders && this.props.parameters.load_loaders.get('value')) ||
            (this.props.parameters.unload_loaders && this.props.parameters.unload_loaders.get('value')),
    }

    componentWillReceiveProps(nextProps) {
        const loadersChecked = (nextProps.parameters.load_loaders && nextProps.parameters.load_loaders.get('value')) ||
            (nextProps.parameters.unload_loaders && nextProps.parameters.unload_loaders.get('value'))

        if (this.state.loadersChecked !== loadersChecked) {
            ActionCreators.updateParameter({
                loaders: loadersChecked,
            })

            if (!loadersChecked) {
                ActionCreators.updateParameter({
                    packing_services: false,
                    dismantling_assembling_furniture: false,
                })
            }

            this.props.onChangeService({attribute: nextProps.parameters['loaders'].set('value', loadersChecked)})
        }

        this.setState({
            loadersChecked,
        })
    }

    getEscortMaxValue = (loadersChecked = false) => {
        const loadersCount = this.props.services.get('price_loader') ? this.props.services.get('price_loader').count_loader : 2

        if (loadersChecked) {
            if (loadersCount === 1) {
                return 1
            }

            if (loadersCount === 2) {
                return 0
            }

            if (loadersCount > 2) {
                return 0
            }
        }

        return 999
    }

    toggleValueParameter = (parameter) => {
        const name = parameter.name;
        const value = !parameter.value;

        if (!this.props.partDay.size) {
            return;
        }

        if (name === 'driver_help' || name === 'insurance' || name === 'time_to_load') {
            return;
        }

        if ((name === 'packing_services' || name === 'dismantling_assembling_furniture') && !this.state.loadersChecked) {
            return;
        }

        if (name === 'escort') {
            if (this.state.loadersChecked) {
                ActionCreators.updateParameter({
                    [name] : 0,
                })

                ActionCreators.calculateInstantBookingPrice();
                return;
            }

            if (value) {
                ActionCreators.updateParameter({
                    [name] : 1,
                })
            } else {
                ActionCreators.updateParameter({
                    [name] : 0,
                })
            }

            ActionCreators.calculateInstantBookingPrice();
            return;
        }

        if (name === 'loaders') {
            this.setState({
                loadersChecked: value,
            })

            ActionCreators.setLoadersExpanded(value);
            ActionCreators.dumpInstantBookingLoaders(value)

            if (value) {
                ActionCreators.setInstantBookingLoadersSaved(false)

                if (this.props.dumpedLoaders) {
                    ActionCreators.updateParameter({
                        ...this.props.dumpedLoaders,
                    })
                } else {
                    ActionCreators.updateParameter({
                        loaders: true,
                        load_loaders: true,
                        unload_loaders: true,
                        load_elevator: [],
                        unload_elevator: [],
                        load_floor: undefined,
                        unload_floor: undefined,
                        packing_services: false,
                        dismantling_assembling_furniture: false,
                    })
                }

                const escortMax = this.getEscortMaxValue(value)
                const escort = this.props.parameters.escort && this.props.parameters.escort.value ? this.props.parameters.escort.value : 0

                if (escort > escortMax) {
                    ActionCreators.updateParameter({
                        escort: escortMax,
                    })
                }
            } else {
                ActionCreators.setInstantBookingLoadersSaved(true)
                ActionCreators.updateParameter({
                    loaders: false,
                    load_loaders: false,
                    unload_loaders: false,
                    load_elevator: [],
                    unload_elevator: [],
                    load_floor: undefined,
                    unload_floor: undefined,
                    packing_services: false,
                    dismantling_assembling_furniture: false,
                })
            }

            this.props.onChangeService({attribute: this.props.parameters['loaders'].set('value', value)})

            ActionCreators.calculateInstantBookingPrice();
            return;
        }

        ActionCreators.updateParameter({
            [name] : value,
        })

        //edit
        // this.props.onChangeService(parameter);
        ActionCreators.calculateInstantBookingPrice();
    }

    renderParams = (iconParams) => {
        let resultParams = [];

        iconParams.map((parameter) => {
            const iconClasses = ClassNames(
                'Parameter-Icon',
                {'Parameter-Icon--disabled': !parameter.value},
                {'Parameter-Icon--animated': parameter.value},
                {'Parameter-Icon--hover': this.props.partDay.size},
            );

            resultParams.push(
                <span
                    key={parameter.name}
                    className={iconClasses}
                    onClick={() => this.toggleValueParameter(parameter)}
                    title={parameter.title}>
                    <IconSVG
                        src={require(`!svg-inline!../InstantBookingScreen/Icons/${parameter.path}`)}/>

                    {
                        ((parameter.name === 'packing_services' || parameter.name === 'dismantling_assembling_furniture') && !this.state.loadersChecked && this.props.partDay.size) ?
                        <Tip
                            label="Доступно только вместе с грузчиками"/>
                            :
                            null
                    }
                    {
                        (parameter.name === 'escort' && this.state.loadersChecked && this.props.partDay.size) ?
                            <Tip
                                label="Сопровождение невозможно, если выбраны грузчики"/>
                            :
                            null
                    }

                </span>
            );
        });

        return resultParams;
    };

    render() {

        const { parameters } = this.props;
        let iconParams = [
            /*{
                name: 'driver_help',
                path: 'Driver-help/Default.svg',
                title: 'Помощь водителя',
                value: true,
            },*/
            /*{
                name: 'insurance',
                path: 'Insurance/Default.svg',
                title: 'Страхование груза',
                value: true,
            },*/
            {
                name: 'loaders',
                path: 'Loader/Default.svg',
                title: parameters['loaders'].get('title'),
                value: parameters['loaders'].get('value'),
            },
            {
                name: 'packing_services',
                path: 'Packaging/Default.svg',
                title: parameters['packing_services'].get('title'),
                value: parameters['packing_services'].get('value'),
            },
            {
                name: 'dismantling_assembling_furniture',
                path: 'Fix/Default.svg',
                title: parameters['dismantling_assembling_furniture'] && parameters['dismantling_assembling_furniture'].get('title'),
                value: parameters['dismantling_assembling_furniture'] && parameters['dismantling_assembling_furniture'].get('value'),
            },
            {
                name: 'escort',
                path: 'Add-extra-sit/Default.svg',
                title: parameters['escort'].get('title'),
                value: parameters['escort'].get('value'),
            },
            {
                name: 'round_trip',
                path: 'Round-trip/Default.svg',
                title: parameters['round_trip'] && parameters['round_trip'].get('title'),
                value: parameters['round_trip'] && parameters['round_trip'].get('value'),
            },
        ];

        if (!parameters['loaders'].get('value')) {
            iconParams.splice(1, 0,
                {
                    name: 'time_to_load',
                    path: 'Time-to-load/Default.svg',
                    title: 'Время на погрузку 40 минут',
                    value: true,
                }
            )
        }

        let selectedParams = iconParams.filter(param => param.value);
        let unselectedParams = iconParams.filter(param => !param.value);
        iconParams = selectedParams.concat(unselectedParams);


        return (
            <div className="InfoBlockParametersIcons">
                <div className="InfoBlockParametersIcons-title">Включено в стоимость перевозки: </div>
                {this.renderParams(iconParams)}
            </div>
        )
    }

}

export default InfoBlockParametersIcons;



/*        resultParams.push(
            <IconSVG
                key="driver_help"
                className="Parameter-Icon"
                src={require('!svg-inline!../InstantBookingScreen/Icons/Driver-help/Default.svg')}
                title="Помощь водителя"/>
        );

        {
            !parameters.loaders.value &&
            resultParams.push(
                <IconSVG
                    key="time_to_load"
                    className="Parameter-Icon"
                    src={require('!svg-inline!../InstantBookingScreen/Icons/Time-to-load/Default.svg')}
                    title="Время на погрузку 40 минут"/>
            );
        }

        resultParams.push(
            <IconSVG
                key="insurance"
                className="Parameter-Icon"
                src={require('!svg-inline!../InstantBookingScreen/Icons/Insurance/Default.svg')}
                title="Страхование груза"/>
        );*/

/*        Object.keys(parameters).forEach((param, index) => {
            const value = parameters[param].get('value');

            let iconClasses = ClassNames(
                'Parameter-Icon',
                {'Parameter-Icon-disabled': !value}
            );

            switch (parameters[param].get('name')) {
                case 'loaders':
                    resultParams.push(
                        <IconSVG
                            key={`${parameters[param].get('name')}-${index}-1`}
                            className={iconClasses}
                            src={require('!svg-inline!../InstantBookingScreen/Icons/Loader/Default.svg')}
                            title={parameters[param].get('title')}/>
                    );
                    break;

                case 'packing_services':
                    resultParams.push(
                        <IconSVG
                            key={`${parameters[param].get('name')}-${index}-1`}
                            className={iconClasses}
                            src={require('!svg-inline!../InstantBookingScreen/Icons/Packaging/Default.svg')}
                            title={parameters[param].get('title')}/>
                    );
                    break;

                case 'escort':
                    resultParams.push(
                        <IconSVG
                            key={`${parameters[param].get('name')}-${index}-1`}
                            className={iconClasses}
                            src={require('!svg-inline!../InstantBookingScreen/Icons/Add-extra-sit/Default.svg')}
                            title={parameters[param].get('title')}/>
                    );
                    break;

                case 'round_trip':
                    resultParams.push(
                        <IconSVG
                            key={`${parameters[param].get('name')}-${index}-1`}
                            className={iconClasses}
                            src={require('!svg-inline!../InstantBookingScreen/Icons/Round-trip/Default.svg')}
                            title={parameters[param].get('title')}/>
                    );
                    break;

                case 'dismantling_assembling_furniture':
                    resultParams.push(
                        <IconSVG
                            key={`${parameters[param].get('name')}-${index}-1`}
                            className={iconClasses}
                            src={require('!svg-inline!../InstantBookingScreen/Icons/Fix/Default.svg')}
                            title={parameters[param].get('title')}/>
                    );
                    break;
            }
        });

        return resultParams;*/



// WEBPACK FOOTER //
// ./client/components/SidebarHeaderBlock/InfoBlockParametersIcons.js